import {
  FormFieldSchema,
  FormFieldType, TriggerType, TriggerCondition,
} from "@app/components/forms/types/schema"

// 회원가입의 카드 등록에서 스키마 같은 점 중복 제거 필요
export const PaymentMethodModalSchema: FormFieldSchema[] = [
  {
    type: FormFieldType.RadioGroup,
    id: "cardType",
    label: "카드 타입",
    hideIndicator: false,
    defaultValue: "personal",
    optionLayout: "horizontal",
    options: [
      {
        label: <div>개인 카드</div>,
        value: "personal",
      },
      {
        label: <div>법인 카드</div>,
        value: "corporation",
      },
    ],
  },
  {
    id: "paymentMethod",
    noneStyle: true,
    type: FormFieldType.Group,
    layout: "horizontal",
    schemas: [
      {
        id: "cardNumber",
        label: "카드번호",
        placeholder: "0000000000000000",
        type: FormFieldType.Text,
        behavior: {
          required: true,
        },
        minLength: 16,
        maxLength: 16,
      },
      {
        id: "cardExpiration",
        label: "유효기간",
        placeholder: "MMYY",
        type: FormFieldType.Password,
        behavior: {
          required: true,
        },
        minLength: 4,
        maxLength: 4,
      },
      {
        id: "customerBirthday",
        label: "생년월일",
        placeholder: "YYMMDD",
        type: FormFieldType.Password,
        behavior: {
          triggers: [
            {
              type: TriggerType.Show,
              field: "cardType",
              value: "personal",
              condition: TriggerCondition.Equal,
            },
          ],
        },
        minLength: 6,
        maxLength: 6,
      },
      {
        id: "businessNumber",
        label: "사업자 번호(숫자만)",
        placeholder: "000-00-00000",
        type: FormFieldType.Password,
        behavior: {
          triggers: [
            {
              type: TriggerType.Show,
              field: "cardType",
              value: "corporation",
              condition: TriggerCondition.Equal,
            },
          ],
        },
        minLength: 10,
        maxLength: 10,
      },
      {
        id: "cardPassword",
        label: "카드 비밀번호(앞 2자리)",
        placeholder: "NN",
        type: FormFieldType.Password,
        behavior: {
          required: true,
        },
        minLength: 2,
        maxLength: 2,
      },
    ],
  },
];
